// extracted by mini-css-extract-plugin
export default {"travel_main":"index_travel_main_I1oxE","con_box":"index_con_box_JZoTk clearfix","lis_nopic":"index_lis_nopic_X1IxS"};